/**
 * @file Password input type - extends String with password display/edit behavior
 * @version 1.0.0
 */

import { StringInputType } from './string.js';

export const PasswordInputType = {
  name: 'password',
  matches: getAttribute => getAttribute('format') === 'password',
  displayComponent: {
    name: 'PasswordDisplay',
    extends: StringInputType.displayComponent,
    data() {
      return {
        showPassword: false,
      };
    },
    methods: {
      formatDisplayValue(value) {
        if (!value) return '';
        return this.showPassword ? value : '•'.repeat(value.length);
      },
    },
    template: `
      <span>
        {{ formattedValue }}
        <i
          class="bi small text-muted ms-2"
          :class="showPassword ? 'bi-eye-slash' : 'bi-eye'"
          style="cursor: pointer;"
          @click.stop="showPassword = !showPassword"
        ></i>
      </span>
    `,
  },
  editComponent: {
    name: 'PasswordEdit',
    extends: StringInputType.editComponent,
    data() {
      return {
        showPassword: false,
      };
    },
    methods: {
      getInputType() {
        return this.showPassword ? 'text' : 'password';
      },
    },
    template: `
      <div class="d-flex gap-2 align-items-center">
        <input
          :type="inputType"
          class="form-control form-control-sm"
          :class="{ 'is-invalid': validationError }"
          :value="value || ''"
          v-bind="inputAttributes"
          style="min-width: 150px"
          @input="handleInput"
          @keydown="$emit('keydown', $event)"
          @blur="$emit('blur', $event)"
        />
        <i
          class="bi small text-muted ms-2"
          :class="showPassword ? 'bi-eye-slash' : 'bi-eye'"
          style="cursor: pointer;"
          @click="showPassword = !showPassword"
        ></i>
      </div>
    `,
  },
};

export default PasswordInputType;
